import { render } from "./MovieListItem.vue?vue&type=template&id=3243e3f4&scoped=true"
import script from "./MovieListItem.vue?vue&type=script&lang=js"
export * from "./MovieListItem.vue?vue&type=script&lang=js"

import "./MovieListItem.vue?vue&type=style&index=0&id=3243e3f4&lang=postcss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3243e3f4"]])

export default __exports__